import AdminApp from "admin/App";
import "./App.css";
import DashboardApp from "dashboard/App";
import SiteApp from "site/App";

function App() {
  const { pathname } = window.location;
  if(pathname.includes("/admin")){
    return <AdminApp/>
  }else if( pathname.includes("/d/")){
    return <DashboardApp/>
  }else {
    return <SiteApp/>
  }
}

export default App;
